import Axios from 'axios';
import ENV from './env';

export default {
  
  /**
   * Search brand Master Video
   */
  getSearchVideo(query) {

    const {
      keyword,
      page,
    } = query;

    return Axios(`${ENV.ERP_PORT}/api/v1/bm/videos?page=${page}&keyword=${keyword}`)
    .then((response) => {

      const resultData = response.data;

      const {
        data,
        total_pages,
      } = resultData;

      return {
        data,
        total_pages,
      };

    })
    .catch(error => console.log(error));
  },

};



// WEBPACK FOOTER //
// ./src/services/search.js